gsap.from(".logo", {
	duration: 1,
	scale: 0.5
});

// var w = window.innerWidth;
// var size = w > 768 ? "big" : "small";
// if (size === "big") {
// 	if (objects.is_onepage || objects.is_front_page) {

// 		gsap.registerPlugin(ScrollTrigger);
	
// 		const firstElem = document.querySelector(".panel");
	
// 		function goToSection(i, anim) {
// 			gsap.to(window, {
// 				scrollTo: {
// 					y: i * innerHeight + firstElem.offsetTop,
// 					autoKill: false
// 				},
// 				duration: 1
// 			});
	
// 			if (anim) {
// 				anim.restart();
// 			}
// 		}
	
		
	
// 		gsap.utils.toArray(".panel").forEach((panel, i) => {
	
// 			let tl_enter_test = gsap.timeline({paused: true});
// 			tl_enter_test.from(panel.querySelectorAll('.inner .right'), {
// 				duration: 2,
// 				y: 2000,
// 				opacity: 0
// 			}, 0);
// 			tl_enter_test.from(panel.querySelectorAll('.inner .left'), {
// 				duration: 2,
// 				y: -2000,
// 				opacity: 0
// 			}, 0);
	
// 			let tl_leave_test = gsap.timeline({paused: true});
// 			tl_leave_test.to(panel.querySelectorAll('.inner .right'), {
// 				duration: 2,
// 				y: -2000,
// 				opacity: 0
// 			}, 0);
// 			tl_leave_test.to(panel.querySelectorAll('.inner .left'), {
// 				duration: 2,
// 				y: 2000,
// 				opacity: 0
// 			}, 0);
	
// 			let tl_leave_back_test = gsap.timeline({paused: true});
// 			tl_leave_back_test.to(panel.querySelectorAll('.inner .right'), {
// 				duration: 2,
// 				y: 0,
// 				opacity: 1
// 			}, 0);
// 			tl_leave_back_test.to(panel.querySelectorAll('.inner .left'), {
// 				duration: 2,
// 				y: 0,
// 				opacity: 1
// 			}, 0);
	
// 			let tl_enter_back_test = gsap.timeline({paused: true});
// 			tl_enter_back_test.to(panel.querySelectorAll('.inner .right'), {
// 				duration: 2,
// 				y: 2000,
// 				opacity: 0
// 			}, 0);
// 			tl_enter_back_test.to(panel.querySelectorAll('.inner .left'), {
// 				duration: 2,
// 				y: -2000,
// 				opacity: 0
// 			}, 0);
			
	
// 			// NEXT PANEL ON FORWARD
// 			let tl_panel_next = gsap.timeline({
// 				scrollTrigger: {
// 					trigger: panel,
// 					onEnter: () => {
// 						goToSection(i);
// 					}
// 				}
// 			});
	
// 			let tl_panel_next_content = gsap.timeline({
// 				scrollTrigger: {
// 					//markers: true,
// 					trigger: panel,
// 					start: "top center",
// 					end: "51% center",
// 					onEnter: () => {
// 						tl_enter_test.play(0);
// 					},
// 					onLeave: () => {
// 						tl_leave_test.play(0);
// 					}
// 				}
// 			});
	
// 			// PREV PANEL ON BACKWARD
// 			let tl_panel_prev = gsap.timeline({
// 				scrollTrigger: {
// 					trigger: panel,
// 					start: "bottom bottom",
// 					onEnterBack: () => {
// 						goToSection(i);
// 					}
// 				}
// 			});
	
// 			let tl_panel_prev_content = gsap.timeline({
// 				scrollTrigger: {
// 					//markers: true,
// 					trigger: panel,
// 					start: "49% center",
// 					end: "bottom center",
// 					onEnterBack: () => {
// 						tl_leave_back_test.play(0);
// 					},
// 					onLeaveBack: () => {
// 						tl_enter_back_test.play(0);
// 					}
// 				}
// 			});
// 		});
	
// 	};
// }




AOS.init();

if ( $('.swiper-container-accueil .swiper-slide').length > 1 ) {
	var swiper = new Swiper('.swiper-container-accueil', {

		speed: 1000,
		parallax: true,
		loop: true,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		navigation: {
			nextEl: '#slider-accueil .swiper-button-next',
			prevEl: '#slider-accueil .swiper-button-prev',
		},
		on: {

			init: function () {
				console.log('swiper initialized');
			},

			slideChangeTransitionStart: function () {
				$('.aos').hide(0);
				$('.aos').removeClass('aos-init').removeClass('aos-animate');
			},
			slideChangeTransitionEnd: function () {
				$('.aos').show(0);
				AOS.init();
			},
		}
	});
}

var swiper = new Swiper('#slider-partenaires .swiper-container-partenaires', {
	speed: 1000,
	slidesPerView: 3,
	spaceBetween: 30,
	centeredSlides: true,
	loop: true,
	loopFillGroupWithBlank: true,
	navigation: {
		nextEl: '#slider-partenaires .swiper-button-next',
		prevEl: '#slider-partenaires .swiper-button-prev',
	},
	breakpoints: {
		320: {
			slidesPerView: 1,
			spaceBetween: 20
		},
		472: {
			slidesPerView: 3,
			spaceBetween: 10
		},
		768: {
			slidesPerView: 5,
			spaceBetween: 20
		}
	}
});

//HOME - FEATURED WORDS
var swiper_abc_keywords = new Swiper('.swiper-abc-keywords', {
	autoplay: {
		delay: 6000,
	},
	speed: 1000,
	pagination: {
		el: '.swiper-abc-keywords-pagination',
		clickable: true,
		disableOnInteraction: true,
	},
	on: {
		touchStart: function (i) {
			//var index = this.realIndex + 1;
			// console.log("start");
			$('.swiper-abc-keywords .keyword-left').addClass('leave');
		},
		touchEnd: function (i) {
			// console.log("end");
			$('.swiper-abc-keywords .keyword-left').removeClass('leave');
		}
	}
});

$(".swiper-abc-keywords").mouseenter(function() {
    swiper_abc_keywords.autoplay.stop();
  });

$(".swiper-abc-keywords").mouseleave(function() {
	swiper_abc_keywords.autoplay.start();
});

//UNIVERS
var swiper_abc_marques = new Swiper('.swiper-abc-marques', {
	loop: true,
	slidesPerView: 1,
	spaceBetween: 0,
	centeredSlides: true,
	allowTouchMove: false,
	effect: 'fade',
	fadeEffect: {
		crossFade: true
	},
	// on: {
	// 	slideChange: function (i) {
	// 		$('.marque-nav').removeClass('active');
	// 		$('.marque-nav:nth-of-type(' + (this.activeIndex + 1)+ ')').addClass('active');
	// 	}
	// },
});

if ( $('.swiper-abc-marques-logo .swiper-slide').length > 1 && $('.swiper-abc-marques-logo .swiper-slide').length < 3 ) {
	var swiper_abc_marques_logo = new Swiper('.swiper-abc-marques-logo', {
		spaceBetween: 30,
		centeredSlides: true,
		breakpoints: {
			320: {
				slidesPerView: 1,
				spaceBetween: 20
			},
			768: {
				slidesPerView: 2,
				spaceBetween: -250
			},
			1280: {
				slidesPerView: 2,
				spaceBetween: -300
			}
		},
		navigation: {
			nextEl: '.swiper-abc-marques-logo .swiper-button-next',
			prevEl: '.swiper-abc-marques-logo .swiper-button-prev',
		},
		on: {
			slideChange: function (i) {
				swiper_abc_marques.slideTo(this.realIndex + 1);
			}
		},
		slideToClickedSlide : true,
	});
} else if ( $('.swiper-abc-marques-logo .swiper-slide').length > 1 ) {
	var swiper_abc_marques_logo = new Swiper('.swiper-abc-marques-logo', {
		spaceBetween: 30,
		centeredSlides: true,
		loop: true,
		breakpoints: {
			320: {
				slidesPerView: 1,
				spaceBetween: 20
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 30
			},
			1280: {
				slidesPerView: 3,
				spaceBetween: 40
			}
		},
		navigation: {
			nextEl: '.swiper-abc-marques-logo .swiper-button-next',
			prevEl: '.swiper-abc-marques-logo .swiper-button-prev',
		},
		on: {
			slideChange: function (i) {
				swiper_abc_marques.slideTo(this.realIndex + 1);
			}
		},
		slideToClickedSlide : true,
	});
} else {
	$('.swiper-abc-marques-logo .swiper-button-prev, .swiper-abc-marques-logo .swiper-button-next').hide();
}